import React, { useEffect, useState } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Select, FormHelperText, Checkbox, ListItemText } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { LocationService } from "../../service/locationService";
import { EmployeeService } from '../../service/employeeService'
import { getTimeRange, toTitleCase } from "../../utils";
import { appSettings } from '../../data';
// import { useAppContext } from "../../state/appState";
import { useQuery } from "react-query";

/***************************************************************
 * Practioner Selector
 ****************************************************************/
export const SelectPractioner = ({ practitioner, setPractitioner, fullWidth, sx }) => {
    // const { appState } = useAppContext();
    const [practitioners, setPractitioners] = useState([]);

    useEffect(() => {
        EmployeeService.getPractitioners().then(result => {
            const { code, data } = result;
            if( code === 0 ) {
                setPractitioners(data);
            }
        }).catch(error => console.log(error));
    },[]);

    // useEffect(() => {
    //     EmployeeService.getLocations().then(result => {

    //         if( result.code === 0 ) {
    //             setData(result.data);
    //         }
    //     }).catch(error => console.log(error));
    // },[]);

    const handleChange = (event) => { setPractitioner(event.target.value);}

    return (
        <FormControl fullWidth={fullWidth} size="small" sx={{
            minWidth: "200px",
            ...sx
        }}>
            <InputLabel id="practioner-select-label">Practitioner</InputLabel>
            <Select
                labelId="practitioner-select-label"
                id="practitioner-select"
                value={practitioner}
                label="practitioner"
                onChange={handleChange}
            >
                {practitioners.map(p=> (
                    <MenuItem 
                    key={p.id} 
                    value={p.id}>{toTitleCase(p.fullName)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

/***************************************************************
 * Practitioners Multi-Selector
 ***************************************************************/
export const SelectPractitionersMulti = ({ practitionerIds = [], setPractitionerIds, fullWidth, sx }) => {
    const [practitioners, setPractitioners] = useState([]);

    useEffect(() => {
        EmployeeService.getPractitioners().then(result => {
            const { code, data } = result;
            if (code === 0) setPractitioners(data);
        }).catch(console.error);
    }, []);

    const handleChange = (event) => {
        const value = event.target.value;
        setPractitionerIds(Array.isArray(value) ? value : []);
    };

    const renderValue = (selected) => {
        if (!selected || selected.length === 0) return "";
        const names = selected
            .map(id => practitioners.find(p => p.id === id)?.fullName || `#${id}`)
            .filter(Boolean);
        return names.join(", ");
    };

    return (
        <FormControl fullWidth={fullWidth} size="small" sx={{ minWidth: "220px", ...sx }}>
            <InputLabel id="practitioners-multi-label">Practitioners</InputLabel>
            <Select
                labelId="practitioners-multi-label"
                id="practitioners-multi"
                multiple
                value={practitionerIds}
                label="Practitioners"
                onChange={handleChange}
                renderValue={renderValue}
            >
                {practitioners.map(p => (
                    <MenuItem key={p.id} value={p.id}>
                        <Checkbox checked={practitionerIds.includes(p.id)} size="small" />
                        <ListItemText primary={toTitleCase(p.fullName)} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

/***************************************************************
 * Location Selector
 ****************************************************************/

export const SelectLocation = ({ location, setLocation, fullWidth, sx, error = null, helperText = null, required = false }) => {

    // Use useQuery to fetch locations
    const { data: locationsData, isLoading, isError, error: queryError } = useQuery(
        'locations', // Unique query key for caching
        LocationService.getLocations, // The function that returns a Promise (your service call)
        {
            // Optional: Add options here
            // staleTime: 5 * 60 * 1000, // Data is considered fresh for 5 minutes
            // refetchOnWindowFocus: false, // Don't refetch when window regains focus
            select: (result) => { // Use 'select' to transform the data if needed
                // Assuming LocationService.getLocations() returns { code, data, message }
                if (result.code === 0 && result.data) {
                    return result.data; // Assuming 'data' contains an 'items' array
                }
                return []; // Return empty array on error or unexpected structure
            }
        }
    );

    // Derive the actual locations array
    const locations = locationsData || [];

    const handleChange = (event) => {
        //const selectedId = typeof event.target.value === 'string' ? parseInt(event.target.value, 10) : event.target.value;
        //const loc = locations.find(l => l.id === selectedId) || null;

        const loc = locations.filter(l => l.id === event.target.value).pop() || null;

        setLocation(loc);
    };

    // Handle loading and error states for the UI
    if (isLoading) {
        return (
            <FormControl
                fullWidth={fullWidth}
                size="small"
                required={required}
                sx={{ minWidth: "200px", ...sx }}
                disabled // Disable while loading
            >
                <InputLabel id="location-select-label">Location</InputLabel>
                <Select
                    labelId="location-select-label"
                    id="location-select"
                    value=""
                    label="Location"
                >
                    <MenuItem value="">Loading...</MenuItem>
                </Select>
                {helperText && <FormHelperText error>{helperText}</FormHelperText>}
            </FormControl>
        );
    }

    if (isError) {
        // You might want to show a more user-friendly error message or retry button
        console.error("Error fetching locations in SelectLocation:", queryError);
        return (
            <FormControl
                fullWidth={fullWidth}
                size="small"
                required={required}
                sx={{ minWidth: "200px", ...sx }}
                error={true} // Indicate error state
            >
                <InputLabel id="location-select-label">Location</InputLabel>
                <Select
                    labelId="location-select-label"
                    id="location-select"
                    value=""
                    label="Location"
                    disabled // Disable on error
                >
                    <MenuItem value="">Error loading locations</MenuItem>
                </Select>
                <FormHelperText error>Failed to load locations.</FormHelperText>
            </FormControl>
        );
    }

    return (
        <FormControl
            fullWidth={fullWidth}
            size="small"
            required={required}
            sx={{
                minWidth: "200px",
                ...sx
            }}
            error={!!error}
        >
            <InputLabel id="location-select-label">Location</InputLabel>
            <Select
                labelId="location-select-label"
                id="location-select"
                value={location || ''}
                label="Location"
                onChange={handleChange}
            >
                {/* Optional: Add a "None" or "Select One" option */}
                {/* <MenuItem value=""><em>None</em></MenuItem> */}
                {locations.map((loc) => (
                    <MenuItem key={loc.id} value={loc.id}>{toTitleCase(loc.name)}</MenuItem>
                ))}
            </Select>
            {helperText && <FormHelperText error>{helperText}</FormHelperText>}
        </FormControl>
    );
};


/***************************************************************
 * Time Selector
 ****************************************************************/
 export const SelectTime = ({ location, setLocation, fullWidth, sx }) => {
     const [time] = useState([]);

    useEffect(() => {
        getTimeRange({h: appSettings.businessStartHour, m: 0 }, {h: appSettings.businessClosingHour, m: 0}, appSettings.timeSlotInterval);
    },[]);

    const handleChange = (event) => { 
        setLocation(event.target.value);
    }

    return (
        <FormControl fullWidth={fullWidth} size="small" sx={{
            minWidth: "200px",
            ...sx
        }}>
            <InputLabel id="time-select-label">Time</InputLabel>
            <Select
                labelId="time-select-label"
                id="time-select"
                value={time}
                label="Location"
                onChange={handleChange}
            >

                {time.map((time) => (
                    <MenuItem key={time} value={time}>{time}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

// function withData(WrappedComponent, data) {

//     return () => {
//         const [locationData, setLocationData] = useState([]);
//         useEffect(() => {
//             data.then(result => {
    
//                 if( result.code === 0 ) {
//                     setLocationData(result.data);
//                 }
//             }).catch(error => console.log(error));
//         },[]);


//         return <WrappedComponent data={locationData}/>
//     }
// }

// export const listWithData = withData(
//     SelectLocation,
//     (DataSource) =>  DataSource.getLocations()
// );